import script from "./Menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menu.vue?vue&type=script&lang=ts&setup=true"

import "./Menu.vue?vue&type=style&index=0&id=4a4409d6&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3182222765/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4409d6"]])

export default __exports__